import {
  Injectable,
  Optional,
} from '@angular/core';
import {
  Contact,
  FrequentFlyerCard,
  Traveler,
} from '@dapi/sdk';
import {
  upsertAndSelectCartEntity,
} from '@des/store/cart';
import {
  Actions,
  createEffect,
  ofType,
} from '@ngrx/effects';
import {
  Action,
  select,
  Store,
} from '@ngrx/store';
import {
  ConfigurationBaseService,
  ConfigurationObserver,
} from '@o3r/configuration';
import {
  AnalyticsService,
  AnalyticsSetTraveller,
  buildTravellers,
} from '@refx/analytics-core';
import {
  getElementFromSessionStorage,
  REFX_COMPONENTS_COMMON_RUNTIME_CONFIG_DEFAULT,
  REFX_COMPONENTS_COMMON_RUNTIME_CONFIG_ID,
  RefxComponentsCommonRuntimeConfig,
  SessionStorageData,
} from '@refx/shared-common';
import {
  selectTravelerDetailsUILoginProfilePrimaryTraveler,
  SetLoginProfileTravelersInTravelerDetailsUI,
  TravelerDetailsUIStore,
} from '@refx/shared-store';
import {
  map,
  Observable,
  withLatestFrom,
} from 'rxjs';

@Injectable()
export class AnalyticsCartEngagementEffect {
  public globalConfig$: Observable<RefxComponentsCommonRuntimeConfig>;

  public populateTravellerForCartEngagement$: Observable<Action>;

  constructor(protected actions$: Actions, protected analyticsService: AnalyticsService, protected store: Store<TravelerDetailsUIStore>,
    @Optional() configurationService?: ConfigurationBaseService) {
    this.globalConfig$ = new ConfigurationObserver<any>(
      REFX_COMPONENTS_COMMON_RUNTIME_CONFIG_ID, REFX_COMPONENTS_COMMON_RUNTIME_CONFIG_DEFAULT, configurationService
    ).asObservable() as Observable<RefxComponentsCommonRuntimeConfig>;
    this.populateTravellerForCartEngagement$ = createEffect(() => this.actions$.pipe(
      ofType(SetLoginProfileTravelersInTravelerDetailsUI, upsertAndSelectCartEntity),
      withLatestFrom(this.store.pipe(select(selectTravelerDetailsUILoginProfilePrimaryTraveler)),
        this.globalConfig$.pipe(map(({globalCartEngagement}) => globalCartEngagement))
      ),
      map(([action, loginProfile, globalCartEngagement]) => {
        const canCollectSensitiveData = getElementFromSessionStorage(SessionStorageData.collectSensitiveData);
        let loyaltyInformation: FrequentFlyerCard[] | undefined;
        let travelers: Traveler[] | undefined;
        let contact: Contact[] | undefined;
        if (action.type === upsertAndSelectCartEntity.type) {
          travelers = action?.entity?.travelers;
          contact = action?.entity.contacts;
          loyaltyInformation = action?.entity?.frequentFlyerCards;
        } else {
          travelers = action?.travelers as Traveler[];
        }
        const showSensitiveData = this.analyticsService.shouldShowSensitiveData() || (canCollectSensitiveData === 'canCollectSensitiveData');
        const loginContacts: Partial<Contact>[] = loginProfile?.contacts ?? [];
        return AnalyticsSetTraveller({
          payload: buildTravellers(showSensitiveData, loyaltyInformation, contact, travelers, undefined, loginContacts, globalCartEngagement)
        });
      })
    ));
  }
}
